import React from "react";
import { useSelector } from "react-redux";

const Topbar = ({ toggle }) => {
  const { user } = useSelector((state) => state.auth);
  return (
    <div className="relative w-full flex justify-end items-center h-10 bg-[#E85B35]">
      <div className="text-white flex items-center mr-12">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="currentColor"
          className="w-[17px] h-[17px] mr-2"
        >
          <path
            fillRule="evenodd"
            d="M7.5 6a4.5 4.5 0 119 0 4.5 4.5 0 01-9 0zM3.751 20.105a8.25 8.25 0 0116.498 0 .75.75 0 01-.437.695A18.683 18.683 0 0112 22.5c-2.786 0-5.433-.608-7.812-1.7a.75.75 0 01-.437-.695z"
            clipRule="evenodd"
          />
        </svg>

        <span className="text-sm">
          { user ? user.email : "Guest Shopper"}
        </span>
      </div>
      {/* Close Button */}
      <button
        className="absolute top-1/2 right-4 -translate-y-1/2"
        aria-label="close_modal"
        onClick={toggle}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="currentColor"
          className="w-5 h-5 text-white"
        >
          <path d="M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z" />
        </svg>
      </button>
    </div>
  );
};

export default Topbar;
